<template>
    <div class="headerBox">
        <div @click="changeActive('')" class="header_title">{{title}}</div>
        <div class="header_sub_title header_sub_title_left" :style="{left:leftFn(subTitleLeft.length)}">
            <div @click="changeActive(item)" v-for="(item,index) in subTitleLeft" :key="index" :class="activeIndex==item?'activeLeft active':''"><div>{{item}}</div></div>
        </div>
        <div class="header_sub_title header_sub_title_right">
            <div @click="changeActive(item)" v-for="(item,index) in subTitleRight" :key="index" :class="activeIndex==item?'activeRight active':''"><div>{{item}}</div></div>
        </div>
        <div class="header_right_box">
            <div>{{date}} {{week}}</div>
            <div>{{time}}</div>
        </div>
        <div class="header_left_box" style="display: none;">
            <div>黄石市</div>
            <div class="header_left_box_img"></div>
            <div>{{weather.name}}</div>
            <div>{{weather.value}}</div>
        </div>
    </div>
</template>
<script>
import Axios from "axios"
export default {
    props:{
        title:{
            type:String,
            default:''
        },
        subTitleLeft:{
            type:Array,
            default:[]
        },
        subTitleRight:{
            type:Array,
            default:[]
        },
        activeItem:{
            type:String,
            default:''
        },
    },
    data(){
        return{
            activeIndex:'',
            date:'',
            time:'',
            week:'',
            weather:{name:'',value:'',img:''}
        }
    },
    methods:{
        changeActive(name){//切换菜单
            if(this.activeIndex!=name){
                this.activeIndex=name;
                this.$emit('changeactiveItem', name);
            }
        },
        leftFn(len){//左边距离
            let val=218+241*len
            return 'calc(50% - '+val+'px)'
        },
        //获取当前日期（年份，月份，时间）：
        getDate() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var curDate = date.getDate();

            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (curDate >= 0 && curDate <= 9) {
                curDate = "0" + curDate;
            }
            
            var currentdate = "";
            currentdate = year + '.' + month + '.' + curDate;
            return currentdate;
        },
        getTime(){
            var date = new Date();
            var curHours = date.getHours();
            var curMinutes = date.getMinutes();
            var curSeconds = date.getSeconds();
            if (curHours >= 0 && curHours <= 9) {
                curHours = "0" + curHours;
            }
            if (curMinutes >= 0 && curMinutes <= 9) {
                curMinutes = "0" + curMinutes;
            }
            if (curSeconds >= 0 && curSeconds <= 9) {
                curSeconds = "0" + curSeconds;
            }
            return curHours+':'+curMinutes+':'+curSeconds;
        },
        getWeek(){
            var tempDate = new Date();
            var days = tempDate.getDay();
            var week;
            switch(days) {
                case 1:
                    week = '星期一';
                    break;
                case 2:
                    week = '星期二';
                    break;
                case 3:
                    week = '星期三';
                    break;
                case 4:
                    week = '星期四';
                    break;
                case 5:
                    week = '星期五';
                    break;
                case 6:
                    week = '星期六';
                    break;
                case 0:
                    week = '星期日';
                    break;
            }
            return week;
        },
        getWeather(){
            this.$httpReq.get('/cockpit/weather?city=漯河').then(res => {
                if(res.data.code == '1' && res.data.data){
                    try {
                        let responseData = JSON.parse(res.data.data);
                            this.dealWeather(responseData.data.forecast[0])
                    } catch (e) {
                    }
                }

            })
        },
        dealWeather(data){
            this.weather.name=data.type;
            this.weather.value=data.low.split(' ')[1]+'-'+data.high.split(' ')[1];
            this.dealImg(data.type)
        },
        dealImg(name){
            var dom=document.getElementsByClassName('header_left_box_img')[0];
            if(name=='小雨'){
                dom.style.backgroundPositionX='-170px'
            }else if(name=='中雨'){
                dom.style.backgroundPositionX='-238px'
            }else if(name=='大雨'){
                dom.style.backgroundPositionX='-68px'
            }else if(name=='多云'){
                dom.style.backgroundPositionX='-34px'
            }else if(name=='晴'){
                dom.style.backgroundPositionX='-102px'
            }else if(name=='阴天'){
                dom.style.backgroundPositionX='0px'
            }else if(name.indexOf('雪')>=0){
                dom.style.backgroundPositionX='-204px'
            }else if(name.indexOf('多云')>=0&&name.indexOf('晴')>=0){
                dom.style.backgroundPositionX='-136px'
            }

        }
    },
    created(){
        this.activeIndex=this.activeItem;
        this.date=this.getDate();
        this.time=this.getTime();
        setInterval(()=>{
            this.time=this.getTime();
        },1000)
        this.week=this.getWeek();
        this.getWeather();
    }
}
</script>
<style lang="scss" scoped>
    .headerBox{
        height: 68px;
        width: 100%;
        background: url('../../../../assets/img/cockpit/headTop.png') no-repeat;
        background-size:100% 100%;
        color: #ffffff;
        position: relative;
        .header_title{
            font-size: 36px;
            font-family: DOUYU-常规体, DOUYU;
            text-align: center;
            line-height: 60px;
        }
        .header_sub_title{
            position: absolute;
            top: 0;
            display: flex;
            align-items: center;
            background: linear-gradient(180deg, #FFFFFF 0%, #1890FF 100%);
            -webkit-background-clip: text;
            color: transparent;
            &>div{
                width: 214px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                cursor: pointer;
            }
            
        }
        .header_sub_title_left{
            &>div{
                background-image: url('../../../../assets/img/cockpit/header_right_gray.png');
            }
        }
        .activeLeft{
            background-image: url('../../../../assets/img/cockpit/header_right.png')!important;
        }
        .header_sub_title_right{
            left: calc(50% + 275px);
            &>div{
                background-image: url('../../../../assets/img/cockpit/header_left_gray.png');
            }
        }
        .activeRight{
            background-image: url('../../../../assets/img/cockpit/header_left.png')!important;
        }
        .active{
            &>div{
                background: linear-gradient(180deg, #FFFFFF 0%, #1890FF 100%);
                -webkit-background-clip: text;
                color: transparent;
                font-weight: bold;
            }
            
        }
        .header_right_box{
            position: absolute;
            right: 16px;
            top: 10px;
            display: flex;
            align-items: center;
            &>div:nth-of-type(1){
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                background: #45A2FF;
                line-height: 16px;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                margin-right: 16px;
            }
            &>div:nth-of-type(2){
                color: rgba(255, 255, 255, 0.87);
                font-size: 14px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
            }
        }
        .header_left_box{
            position:absolute;
            top: 10px;
            left: 16px;
            display: flex;
            align-items: center;
            &>div{
                &:nth-of-type(1){
                    font-size: 14px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    background: rgba(255, 255, 255, 0.87);
                    line-height: 16px;
                    text-shadow: 0px 0px 13px rgba(27, 126, 242, 0.91);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    margin-right: 18px;
                }
                &:nth-of-type(2){

                }
                &:nth-of-type(3){
                    margin: 0 16px 0 4px;
                    font-size: 14px;
                    background: #45A2FF;
                    line-height: 16px;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
                &:nth-of-type(4){
                    font-size: 14px;
                    background: #45A2FF;
                    line-height: 16px;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
            }
        }
        .header_left_box_img{
            background: url('../../../../assets/img/cockpit/tian.png') no-repeat;
            width: 24px;
            height: 24px;
            background-position-y: 0;
        }

    }
</style>